<template>
  <div class="row">
    <div class="col-xs-12 col-md-8">
      <text-box :label="$t('address.street')" required v-model="value.street"></text-box>
    </div>
    <div class="col-xs-6 col-md-2">
      <text-box :label="$t('address.N°')" :max="8" required v-model="value.streetNumber" :rules="{ house_number_valid_characters: true }"></text-box>
    </div>
    <div class="col-xs-6 col-md-2">
      <text-box :label="$t('address.box')" :max="4" v-model="value.streetBox"></text-box>
    </div>
    <div class="col-xs-12 col-md-2">
      <text-box :label="$t('address.zipCode')" required v-model="value.zipCode"></text-box>
    </div>
    <div class="col-xs-12 col-md-6">
      <text-box :label="$t('address.locality')" required v-model="value.locality"></text-box>
    </div>
    <div class="col-xs-12 col-md-4">
      <country-selector :countries="countries" :label="$t('address.country')" required v-model="value.country"></country-selector>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Inject, Prop } from 'vue-property-decorator'
import { ContactAddress, Country } from '@/models'

@Component
export default class AddressForm extends Vue {
  //#region [Data]
  public countries: Country[] = []
  //#endregion

  //#region [Property]
  @Prop({ type: Object, required: true })
  public readonly value!: ContactAddress
  //#endregion

  //#region [Method]
  public mounted() {
    this.$addressRepository
      .get<Country[]>('/countries', {
        cache: {
          cachePredicate: (status) => true,
        }
      })
      .then((response) => {
        const countries = response.data
        const belgiumIndex = countries.findIndex((x) => x.code === 'BE')
        const belgiumCountry = {
          code: 'BE',
          name: 'Belgique',
        }
        if (belgiumIndex !== -1) {
          countries.splice(belgiumIndex, 1)
        }
        this.countries = [belgiumCountry, ...countries]
      })
  }
  //#endregion
}
</script>